export default "__VITE_ASSET__D3MN3ITo__"